import { AnnouncementsWorkspace } from '@/components/announcements/announcements-workspace'

export function CommitteeAnnouncements() {
  return <AnnouncementsWorkspace basePath="/committee/announcements" />
}
